<template>
  <div>
    <b-alert v-if="hasReachedMaxArgumentCount" show variant="danger">
      Nezbývají vám už žádné volné argumenty pro logování. Pokud chcete logovat více argumentů, nastavte si vyšší tarif služeb. <b-link :to="{ name: 'subscription' }">Nastavit</b-link>
    </b-alert>
    <item
      v-for="varItem in getLoggingAllowedVars(service.id)"
      :key="varItem.id"
      :var-item="varItem"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Item from '@/components/logging/settings/Item';

export default {
  name: 'List',
  props: {
    service: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters([
      'getLoggingAllowedVars',
    ]),
    ...mapGetters('paid-subscription', [
      'hasReachedMaxArgumentCount',
    ]),
  },
  components: {
    Item,
  },
};
</script>

<style scoped>
</style>
